/* eslint-disable react/no-unescaped-entities */

"use client";

import { useState } from "react";

import { SiteFooter } from "@/components/SiteFooter";
import { SiteHeader } from "@/components/SiteHeader";

import { faqs } from "./faqData";
import styles from "../legal.module.css";

export default function FAQPage() {
  const [query, setQuery] = useState("");

  const normalizedQuery = query.trim().toLowerCase();
  const filteredFaqs = faqs.filter(({ question, answer, category }) => {
    if (!normalizedQuery) return true;

    return [question, answer, category].some((value) => value.toLowerCase().includes(normalizedQuery));
  });

  return (
    <>
      <SiteHeader />
      <div className={styles.page}>
      <main className={styles.shell}>
        <section className={styles.hero}>
          <div className={styles.heroCard}>
            <span className={styles.eyebrow}>FAQ</span>
            <h1 className={styles.heroTitle}>Des réponses claires pour avancer sans friction.</h1>
            <p className={styles.heroText}>
              Cette page centralise les questions les plus fréquentes sur l'inscription, l'installation,
              la gestion des accès, la continuité d'exploitation et la relation contractuelle avec Pharmapp.
            </p>

            <div className={styles.searchWrap}>
              <i className={`bi bi-search ${styles.searchIcon}`}></i>
              <input
                type="search"
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                placeholder="Rechercher une question, un mot-clé ou un sujet"
                className={styles.searchInput}
                aria-label="Rechercher une FAQ"
              />
            </div>
          </div>

          <aside className={styles.heroAside}>
            <div className={styles.metaCard}>
              <strong>Recherche instantanée</strong>
              <p>Filtrez les réponses par thème, mot-clé ou sujet opérationnel sans parcourir toute la page.</p>
            </div>
            <div className={styles.metaCard}>
              <strong>Informations utiles</strong>
              <p>Les réponses ci-dessous résument le fonctionnement général du service et doivent être lues avec les conditions applicables à votre formule.</p>
            </div>
          </aside>
        </section>

        <section className={styles.section}>
          <div className={styles.faqMeta}>
            <span>{filteredFaqs.length} résultat(s)</span>
            <span>Base de questions fréquentes Pharmapp</span>
          </div>

          {filteredFaqs.length === 0 ? (
            <div className={styles.emptyState}>
              Aucune réponse ne correspond à votre recherche. Essayez un mot plus simple comme compte,
              paiement, installation ou données.
            </div>
          ) : (
            <div className={styles.faqList}>
              {filteredFaqs.map((item, index) => (
                <details key={item.question} className={styles.faqItem} open={index === 0 && !normalizedQuery}>
                  <summary>
                    <span>{item.question}</span>
                    <span className={styles.faqTag}>{item.category}</span>
                  </summary>
                  <p>{item.answer}</p>
                </details>
              ))}
            </div>
          )}
        </section>
      </main>
      </div>
      <SiteFooter />
    </>
  );
}
